export default __webpack_public_path__ + "static/media/selected_tractor_user_rv.4d4c7f46.svg";